import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import { FeaBaseProcessService } from './fea-base-process.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaLoadService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(): Promise<any> {
    const request = await this.feaBaseProcessService.getBaseProcessRequest();

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      const valuesPerElement = await firstValueFrom(this.http.post<{ [id: number]: number }>(environment.API_FEA + `Load/GetResult`, request, options));
      for (let key in valuesPerElement) {
        valuesPerElement[key] = Math.abs(valuesPerElement[key]); // TODO: it's better to have normal and signed values than abs
      }
      return {
        valuesPerElement: valuesPerElement,
        title: "Load Case"
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get load condition");
      return null;
    }
  }
}
